import React, { useState, useEffect } from 'react';

const BriocheLogo = ({ className = "w-8 h-8", showText = false }) => {
  const [customLogo, setCustomLogo] = useState(null);
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    // Check for custom logo in localStorage
    const storedLogo = localStorage.getItem('brioche-custom-logo');
    if (storedLogo) {
      setCustomLogo(storedLogo);
      setLogoError(false);
    }
  }, []);

  const handleLogoError = () => {
    setLogoError(true);
    console.warn('Custom logo failed to load, falling back to default');
  };

  return (
    <div className="flex items-center space-x-3">
      <div className={`${className} relative overflow-hidden`}>
        {/* Custom uploaded logo */}
        {customLogo && !logoError ? (
          <img
            src={customLogo}
            alt="Custom Brioche Logo"
            className="w-full h-full object-contain rounded-lg"
            onError={handleLogoError}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        ) : (
          <>
            {/* Default logo as an image file */}
            <img
              src="/brioche-logo.png"
              alt="Brioche Logo"
              className="w-full h-full object-contain"
              onError={(e) => {
                // Fallback to custom SVG logo if image fails to load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            {/* Fallback: Custom SVG logo (hidden by default) */}
            <svg
              viewBox="0 0 100 100"
              className="w-full h-full"
              style={{ display: 'none' }}
            >
              {/* Crown */}
              <path
                d="M20 25 L35 35 L50 20 L65 35 L80 25 L75 45 L25 45 Z"
                fill="currentColor"
                className="text-brand-accent"
              />
              {/* Face circle */}
              <circle
                cx="50"
                cy="60"
                r="25"
                fill="currentColor"
                className="text-brand-fg"
                stroke="currentColor"
                strokeWidth="2"
              />
              {/* Eyes */}
              <circle cx="42" cy="55" r="2" fill="currentColor" className="text-brand-bg" />
              <circle cx="58" cy="55" r="2" fill="currentColor" className="text-brand-bg" />
              {/* Smile */}
              <path
                d="M 42 68 Q 50 75 58 68"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
                className="text-brand-bg"
              />
            </svg>
          </>
        )}
      </div>
      {showText && (
        <div className="text-brand-fg">
          <div className="font-bold text-xl tracking-wider">BRIOCHE</div>
        </div>
      )}
    </div>
  );
};

export default BriocheLogo;